import { Component, OnInit } from '@angular/core';

interface EkomiData {
  data: {
    average_rating: number;
    review_count: number;
    rating_count: Record<number, number>;
  };
}

@Component({
  selector: 'app-header-trust-elements',
  templateUrl: './header-trust-elements.component.html',
  styleUrls: ['./header-trust-elements.component.scss'],
})
export class HeaderTrustElementsComponent implements OnInit {
  ekomiData: EkomiData;
  rating: number;
  review_count: number;

  constructor() {}

  ngOnInit(): void {
    this.ekomiData = window['wf_ekomi'] as EkomiData;
    this.rating = Math.round(this.ekomiData.data.average_rating);
    this.review_count = this.ekomiData.data.review_count;
  }
}
